import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { ComparableResultsRow, BackButton, SimpleFlexbox } from 'ctm-components';
import { selectedProductSelector, resultsConfigSelector } from 'ctm-selectors';
import { pageContext } from 'ctm-util-functions';
import styles from './more_info.css';

/**
 * More Info Component
 * @extends BaseComponentInterface
 * @desc Used to render the more info page for a product
 * @param {Object} props React props
 * @returns {Node} a More Info Component
 */
const _MoreInfo = (props) => {
    const { product, layout, breakpoint } = props;

    const footerBackBtn = {
        visualProps: { variant: 'full_width', textAlign: 'center' },
        elementProps: { tagName: 'a', href: 'javascript:;' },
        contentProps: { iconPosition: 'before', icon: 'ctm_angle_left', innerHTML: '<strong>Back</strong> to all products' }
    };

    const mobileBackBtn = {
        className: styles.mobile_close_icon,
        visualProps: {
            UIComponent: 'btn_primary_small_rounded',
            variant: ''
        },
        elementProps: { tagName: 'a' },
        contentProps: { icon: 'ctm_cross' }
    };

    return (
        <SimpleFlexbox position="relative">
            <BackButton {...mobileBackBtn} />
            <ComparableResultsRow product={product} layout={layout} breakpoint={breakpoint} />
            <BackButton {...footerBackBtn} />
        </SimpleFlexbox>
    );
};

_MoreInfo.propTypes = {
    breakpoint: PropTypes.string,
    product: PropTypes.object.isRequired,
    layout: PropTypes.array.isRequired,
    frequency: PropTypes.string,
    dispatch: PropTypes.func
};

const mapStateToProps = (state) => {
    return {
        breakpoint: pageContext.getProps().pageState.breakpoint,
        product: selectedProductSelector(state),
        frequency: resultsConfigSelector(state).getIn(['filters', 'frequency'])
    };
};

const MoreInfo = connect(mapStateToProps)(_MoreInfo);
export { _MoreInfo, MoreInfo };
